export const getActiveModules = (user) => {
  try {
    const clients = JSON.parse(user["custom:clients"] || "[]");
    const modules = new Set();

    clients.forEach((client) => {
      client.services?.forEach((service) => {
        if (service.active && service.value) {
          modules.add(service.value.toLowerCase());
        }
      });
    });

    return modules;
  } catch (error) {
    console.error("Error parsing modules from user:", error);
    return new Set();
  }
};

export const filterSidebarItemsByRole = (user, sidebarItems) => {
  const userRole = user?.role?.toLowerCase();
  const activeModules = getActiveModules(user);

  return sidebarItems.filter((item) => {
    const roleCheck =
      !item.allowedRoles || item.allowedRoles.map(r => r.toLowerCase()).includes(userRole);

    // const moduleCheck = activeModules.has(item.id?.toLowerCase()); // commented as user token does not have module access things, will come later
    return roleCheck; //  && moduleCheck;
  });
};
